export class User {
    pk:number;
    username: string;
    password: string;
}

export interface UserInformation {
    authenticated: boolean;
    expiredTime: number;
    status: string;
    token: string;
    user: {
        active: boolean;
        address: string;
        city: string;
        country: string;
        customizedUserID: string;
        dob: Date;
        email: string;
        extraUserId: string;
        firstName: string;
        isInternal: boolean;
        lastName: string;
        pk: number;
        ssn?: string;
        state: string;
        userName: string;
        zipcode: string;
    }
}
